class Viewer {
    constructor() {
        this.frame = document.querySelector('#viewer');
        this.triggers = document.querySelectorAll('.product-config, .config-toggle');
        this.listConfig = document.querySelector('#configs');
        this.waiter = document.querySelector('.config__waiter');
        this.allElements = {};
        this.configs = null;
        this.storage = '';
        this.isInit = false;
        this.init();
    }

    init() {
        Array.from(this.triggers).forEach((trigger) => {
            trigger.addEventListener('click', () => {
                if (!this.isInit) {
                    this.waiter.classList.add('hidden');
                    this.isInit = true;
                    let fullConfigs; // array: all configurations
                    // let ulConfigs = document.getElementById('configs');

                    this.frame.contentWindow.postMessage({
                        type: 'init',
                        hideTuto: true,
                        hideButtonFullscreen: true,
                        hideButtonReset: true,
                        hideButtonScreenshot: true,
                        activateIdleRotation: true, // activation auto rotation
                        backgroundShade: {
                            shadeTop: {
                                r: 255,
                                g: 255,
                                b: 255
                            },
                            shadeDown: {
                                r: 255,
                                g: 255,
                                b: 255
                            }
                        },
                        stringCSSDefault: '.button-list-down{width:0;}'
                    }, '*');

                    window.addEventListener('message', event => {
                        let action = event.data;
                        switch (action.type) {
                            // case 'furnitureLoaded':
                            //     this.viewer.contentWindow.postMessage({
                            //     type: 'getName'
                            //     }, '*');
                            // break;

                            // case 'furnitureName':
                            //     let getName = document.getElementById("get-name");
                            //     getName.innerHTML = action.name.toUpperCase();
                            //     let title = document.querySelector('.title');
                            //     title.style.visibility = 'visible';
                            //     break;

                            case 'APIFullConfig':

                                // DELETE THE OLD MENU
                                this.listConfig.innerHTML = '';

                                fullConfigs = JSON.parse(action.fullconfigObject);

                                // CREATE THE MENU, LOAD THE ELEMENT/MODULE (cf. functions below)
                                fullConfigs.forEach(configs => {
                                    this.createMenu(configs);
                                });

                                /*
                                CLICK ON THE + TO ADD/DELETE A MODULE
                                CLICK ON THE MODULE TO SELECT AND MODIFY IT */

                                break;

                            default:
                                break;
                        };
                    });
                }
            });
        });
    }

    loadConfig(element) {
        this.frame.contentWindow.postMessage({
            type: 'selectConfiguration',
            parameters: JSON.stringify(element)
        }, '*');
    }

    createConfig(element, ulElements, confID) {
        ulElements.classList.add('ulElements');
        let img = document.createElement('img');
        img.setAttribute('src', element.image);

        if (element.is_selected) {
            img.classList.add('active');
        }

        let li = document.createElement('li');
        li.appendChild(img);
        ulElements.appendChild(li);
        // On click, select the element to load, then notify changes
        img.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.storage = element.zone_id || element.anchorId
            Array.from(ulElements.querySelectorAll('img')).forEach((item) => {
                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                }
            });
            if(this.allElements[confID]) {
                Array.from(this.allElements[confID]).forEach((el) => {
                    if(el.is_selected) {
                        el.is_selected = false;
                    }
                });
            }
            element.is_selected = true;

            // Call the function
            this.loadConfig(element);
        });
    }

    checkChildren(element, ulElements, confID) {
        if (element.shades.length > 0) {
            this.allElements[confID] = element.shades;
            element.shades.forEach(shade => this.createConfig(shade, ulElements, confID))
        } else {
            element.children.forEach(child => {
                this.checkChildren(child, ulElements);
            })
        }
    }

    createSubmenu(configs, ulElements) {
        if (configs.type === 'color' && configs.has_category === true) {
            configs.elements.forEach(element => {
                this.checkChildren(element, ulElements, configs.id);
            });
        } else {
            this.allElements[configs.id] = configs.elements;
            configs.elements.forEach(element => {
                this.createConfig(element, ulElements, configs.id);
            });
        }
    }

    displayPopup(configs) {
        const popupCloseButton = document.querySelector('.popup-close-button');
        const popupContainer = document.querySelector('.popup-container');
        let popupTitle = document.getElementById('popup-title');
        let ulElements = document.getElementById('popup-modules');
        ulElements.innerHTML = '';
        popupContainer.style.visibility = 'visible';
        popupTitle.innerHTML = configs.name;
        this.createSubmenu(configs, ulElements);

        // Close popup
        popupContainer.addEventListener('click', () => {
            popupContainer.style.visibility = 'hidden';
        });
        popupCloseButton.addEventListener('click', () => {
            popupContainer.style.visibility = 'hidden';
        });
    }

    createMenu(configs) {
        /* display the popup if :
        -the element is global
        -no module is selected*/
        const moduleSelected = configs.elements.filter(element => element.is_selected === true);
        if (configs.is_global === false && moduleSelected.length === 0) {
            this.displayPopup(configs);
        } else {
            let li = document.createElement('li');
            li.classList.add('list-group-item');
            li.innerHTML = configs.name;
            let ulElements = document.createElement('ul');
            this.listConfig.appendChild(li);
            li.addEventListener('click', () => {
                if(ulElements.innerHTML == '') {
                    li.appendChild(ulElements);
                    this.createSubmenu(configs, ulElements);
                }
                // if (ulElements.innerHTML !== '') {

                //     ulElements.innerHTML = ''
                //     ulElements.classList.remove('hyphen');
                //     ulElements.style.display = "none";
                // } else {
                //     ulElements.style.display = "flex";
                //     ulElements.classList.add('hyphen');
                //     li.appendChild(ulElements);
                //     this.createSubmenu(configs, ulElements);
                // }

                ulElements.classList.toggle('active');
            });
        }
    }
}

export default Viewer;
